import { render, staticRenderFns } from "./UserGuidePopup.vue?vue&type=template&id=0cb8e6c4"
import script from "./UserGuidePopup.vue?vue&type=script&lang=js"
export * from "./UserGuidePopup.vue?vue&type=script&lang=js"
import style0 from "./UserGuidePopup.vue?vue&type=style&index=0&id=0cb8e6c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports